import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { AccountMenu } from './AccountMenu';
import { CvLogo } from './CvLogo';
import Grid from '@mui/material/Grid';

export interface HeaderProps {
  title?: string;
  viewActiveCase: string;
  navigateTo: string;
}

const StyledAppBar = styled(AppBar)(() => ({
  width: '100%',
  background: '#565656',
  color: 'white',
}));

const StyledToolbar = styled(Toolbar)(() => ({
  alignItems: 'inherit',
  paddingRight: 0,
}));

const LogoBox = styled(Typography)(() => ({
  alignItems: 'center',
  display: 'flex',
}));

const TitleGrid = styled(Grid)(() => ({
  display: 'flex',
  width: '80%',
}));

const AppTitleOuter = styled(Typography)(() => ({
  lineHeight: '1.1',
  alignItems: 'center',
  display: 'flex',
}));

const AppTitleLink = styled(Link)(() => ({
  fontFamily: 'sans-serif',
  color: 'white',
  textDecoration: 'none',
  fontWeight: 'bold',
}));

const HeaderViewActive = styled(Grid)(() => ({
  padding: '0 5px 0 5px',
  marginLeft: '15px',
  fontSize: '13px',
  alignItems: 'center',
  display: 'flex',
  '&:hover': {
    backgroundColor: '#837E7C',
  },
}));

const H6 = styled(Typography)(() => ({
  lineHeight: '1.1',
}));

const ViewActiveCaseLink = styled(Link)(() => ({
  color: 'white',
  textDecoration: 'none',
  fontSize: '15px',
}));

export const CvHeader = ({
  title,
  viewActiveCase,
  navigateTo,
}: HeaderProps) => {
  return (
    <StyledAppBar position="relative" color="primary">
      <StyledToolbar>
        <LogoBox>
          <CvLogo />
        </LogoBox>
        <TitleGrid>
          <AppTitleOuter variant="h6">
            <AppTitleLink to={navigateTo}>
              {title ? title : 'Home'}
            </AppTitleLink>
          </AppTitleOuter>
          <HeaderViewActive>
            <H6 variant="h6">
              <ViewActiveCaseLink to={navigateTo}>
                {viewActiveCase ? viewActiveCase : 'Home'}
              </ViewActiveCaseLink>
            </H6>
          </HeaderViewActive>
        </TitleGrid>
        <AccountMenu />
      </StyledToolbar>
    </StyledAppBar>
  );
};
